<script>
export default {
    name: "NonPharmaceuticalsTab"
}
</script>
<template>
<div class="w-full overflow-auto">
    <table class="table">
        <thead class="bg-blue-500 text-xs text-white">
            <tr class="w-full flex">
                <th class="p-tiny w-1/4">Drug</th>
                <th class="p-tiny flex-1">Prescription</th>
                <th class="p-tiny flex-1">Date</th>
                <th class="p-tiny flex-1">Qty</th>
                <th class="p-tiny flex-1">Status</th>
                <th class="p-tiny flex-1">Action</th>
            </tr>
        </thead>
        <tbody class="bg-gray-100 text-xs flex flex-col items-center overflow-auto">
            <tr class="w-full flex">
                <td class="p-tiny w-1/4">
                    Paracetamol
                </td>
                <td class="p-tiny flex-1">
                    2tds
                </td>
                <td class="p-tiny flex-1">
                    <h5 class="text-xs">Time: 12.00</h5>
                    <h5 class="text-xs">User: Test User</h5>
                </td>
                <td class="p-tiny flex-1">
                    <h5 class="text-xs">Qty: 20</h5>
                    <h5 class="text-xs">Paid For: 20</h5>
                    <h5 class="text-xs">Issued: 0</h5>
                    <h5 class="text-xs">Remaining: 20</h5>
                    <h5 class="text-xs">Administered: 0</h5>
                </td>
                <td class="p-tiny flex-1">
                    Processed
                </td>
                <td class="p-tiny flex-1">
                    <button 
                        title="Process"
                        class="btn-sm btn-info text-xs rounded m-1">
                      <i class="fa fa-sync"></i> Process</button>
                    <button
                        class="btn-sm btn-primary text-xs rounded m-1" 
                        title="Prescription History"> 
                        <i class="fa fa-list"></i> History</button>
                    <button 
                        class="btn-sm btn-info text-xs rounded mr-1" title="Dispense">
                            <i class="fa fa-redo"></i> Issue</button>
                    <button type="button"
                        class="btn-sm btn-danger text-xs rounded">
                            <i class="fa fa-undo"></i> Reverse</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>
